import { render, staticRenderFns } from "./MessageText.vue?vue&type=template&id=46fe11da&scoped=true"
import script from "./MessageText.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageText.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MessageText.vue?vue&type=style&index=0&id=46fe11da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fe11da",
  null
  
)

export default component.exports